module.exports = __webpack_public_path__ + "img/andy.8ddfa440.png";